module.exports = __webpack_public_path__ + "img/datastructure_book.cff59fc8.jpg";